module.exports = __webpack_public_path__ + "static/media/cervical-ripening-balloon-steps-of-use-poster@2x.7ba456a4.jpg";